import React, { useState, useEffect } from 'react';
import InputEntidad from '../../common/InputEntidad';
import DatePickerCustom from '../../common/DatePickerCustom';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject, CompareDates} from '../../../utils/helpers';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import {useEntidad} from '../../hooks/useEntidad';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError, FormLabel, Modal} from "../../common";

const CondicionEspecialModal = (props) => {

    const entityInit = {
        id: 0,
        idCuenta: 0,
        idTipoCondicionEspecial: 0,
        fechaDesde: null,
        fechaHasta: null
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
        idTipoTributo: 0
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity, idTipoTributo: props.data.idTipoTributo};
        });
        formSet({
            idTipoCondicionEspecial: props.data.entity.idTipoCondicionEspecial,
            fechaDesde: props.data.entity.fechaDesde,
            fechaHasta: props.data.entity.fechaHasta
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTipoCondicionEspecial: 0,
        fechaDesde: null,
        fechaHasta: null
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    const [, getRowEntidad] = useEntidad({
        entidades: ['TipoCondicionEspecial'],
        onLoaded: (entidades, isSuccess, error) => {
            if (isSuccess) {
                setState(prevState => ({...prevState}));
            } else {
                ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
            }
        },
        memo: {
            key: 'TipoCondicionEspecial',
            timeout: 0
        }
    });

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoCondicionEspecial = parseInt(formValues.idTipoCondicionEspecial);
        row.fechaDesde = formValues.fechaDesde;
        row.fechaHasta = formValues.fechaHasta;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoCondicionEspecial <= 0) errors.idTipoCondicionEspecial = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.fechaDesde == null) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (formValues.fechaHasta != null &&
            CompareDates(formValues.fechaHasta, formValues.fechaDesde) < 0) errors.fechaHasta = 'No puede ser anterior a la fecha desde';

        return errors;
    }

    const getDescTipoCondicionEspecial = (id) => {
        const row = getRowEntidad('TipoCondicionEspecial', id);
        return (row) ? row.nombre : '';
    }

    return (
        <Modal
            size="lg"
            title={`Condición especial: ${(state.entity.id > 0) ? getDescTipoCondicionEspecial(state.entity.idTipoCondicionEspecial) : "Nuevo"}`}
            tipName={TIPS.NAME.MODALS.CONDICION_ESPECIAL_MODAL}
            onEscape={() => props.onDismiss()}
            body={(
                            <div className="row">

                                <div className="mb-3 col-12">
                                    <Accordion title="Condición especial" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-12 col-md-6">
                                                <FormLabel htmlFor="idTipoCondicionEspecial" required>Tipo</FormLabel>
                                                <InputEntidad
                                                    name="idTipoCondicionEspecial"
                                                    tipName={TIPS.NAME.MODALS.TIPO_CONDICION_ESPECIAL_MODAL}
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTipoCondicionEspecial') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTipoCondicionEspecial}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Tipo condición especial"
                                                    entidad="TipoCondicionEspecial"
                                                    filter={row => !row.idTipoTributo || row.idTipoTributo === state.idTipoTributo}
                                                    onFormat={row => (row) ? `${row.codigo} - ${row.nombre}` : ''}
                                                />
                                                <FormError message={errorOf('idTipoCondicionEspecial')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <FormLabel htmlFor="fechaDesde" required>Fecha desde</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaDesde"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaDesde')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <label htmlFor="fechaHasta" className="form-label">Fecha
                                                    hasta</label>
                                                <DatePickerCustom
                                                    name="fechaHasta"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaHasta') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaHasta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaDesde}
                                                />
                                                <FormError message={errorOf('fechaHasta')} />
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Condición Especial"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_CONDICION_ESPECIAL_MODAL}
                                            processKey={props.processKey}
                                            entidad="CondicionEspecial"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>

                            </div>
            )}
            footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
            </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

CondicionEspecialModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

CondicionEspecialModal.defaultProps = {
    disabled: false
};

export default CondicionEspecialModal;